<script>
    export let provider;
    let imageName="";
    switch(provider)
    {
        case "arbor":
            imageName = "/images/arbor.png";
            break;
        case "scholarpack":
            imageName = "/images/ScholarPack.png";
            break;
        case "integris g2":
            imageName = "/images/rmintegris.png";
            break;
        case "bromcom":
            imageName = "/images/Bromcom.png";
            break;
        case "sims":
            imageName ="/images/sims.png";
            break;
        case "pupilasset":
            imageName = "/images/pupilasset.png";
            break;
        case "simsprimary":
            imageName = "/images/simsprimary.png";
            break;
        case "google":
            imageName = "/images/googleEducation.png";
            break;
        case "microsoft":
            imageName = "/images/MSEducation.png";
            break;
    }
</script>
<style>
     img{
        max-height:100px;max-width:100%;
    }
</style>

<img src={imageName} alt={provider} />


